export default function sortTag() {
  const $submit = document.getElementById('js-tagSortSubmit');

  if ($submit === null) return;

  $submit.addEventListener(
    'click',
    (element) => {
      element.preventDefault();
      const form = document.sortTag;
      const formUrl = form.action;
      const params = [];
      let urls = '';
      const theme = form.spot_theme;
      const area = form.spot_area;
      const category = form.spot_category;
      const themeValues = [];
      const areaValues = [];
      const categoryValues = [];
      // eslint-disable-next-line
      if (theme) {
        const nodeThemes = Array.prototype.slice.call(theme, 0);
        if (nodeThemes.length) {
          nodeThemes.forEach((e) => {
            if (e.checked) {
              themeValues.push(e.value);
            }
          });
        } else if (theme.checked) {
          themeValues.push(theme.value);
        }
        if (themeValues.length) {
          const themesString = themeValues.join(',');
          params.push(`spot-theme=${themesString}`);
        }
      }
      if (area) {
        const nodeAreas = Array.prototype.slice.call(area, 0);
        if (nodeAreas.length) {
          nodeAreas.forEach((e) => {
            if (e.checked) {
              areaValues.push(e.value);
            }
          });
        } else if (area.checked) {
          areaValues.push(area.value);
        }
        if (areaValues.length) {
          const areasString = areaValues.join(',');
          params.push(`spot-area=${areasString}`);
        }
      }
      if (category) {
        const nodeCategories = Array.prototype.slice.call(category, 0);
        if (nodeCategories.length) {
          nodeCategories.forEach((e) => {
            if (e.checked) {
              categoryValues.push(e.value);
            }
          });
        } else if (category.checked) {
          categoryValues.push(category.value);
        }
        if (categoryValues.length) {
          const categoriesString = categoryValues.join(',');
          params.push(`spot-category=${categoriesString}`);
        }
      }
      params.forEach((param, index) => {
        if (index === 0) {
          urls += `?${param}`;
        } else {
          urls += `&${param}`;
        }
      });
      window.location.href = formUrl + urls;
    },
    true,
  );
}
